import { InterviewStageFragment, SoftSkillCategory } from 'generated/graphql';

export type SoftSkill = InterviewStageFragment['softSkills'][number];

export type SortedSoftSkills = {
  rightForRole: SoftSkill[];
  rightForUs: SoftSkill[];
  rightForFuture: SoftSkill[];
};

export const sortSoftSkillsByCategory = (
  softSkills: InterviewStageFragment['softSkills']
): SortedSoftSkills => {
  const sorted: SortedSoftSkills = {
    rightForRole: [],
    rightForUs: [],
    rightForFuture: [],
  };

  for (const skill of softSkills) {
    switch (skill.category) {
      case SoftSkillCategory.RightForTheRole:
        sorted.rightForRole.push(skill);
        break;
      case SoftSkillCategory.RightForUs:
        sorted.rightForUs.push(skill);
        break;
      case SoftSkillCategory.RightForTheFuture:
        sorted.rightForFuture.push(skill);
        break;
      default:
        // Ignore other categories like CognitiveSummary
        break;
    }
  }

  return sorted;
};
